const developmentsSchema = [];

export default developmentsSchema;
